export const classes = {
  wrapper: 'flex justify-between items-start w-full mb-1',
  leftContent: 'place-between grow flex-wrap pr-4',
  name: 'text-grey-8 dark:text-mauve-1 font-medium text-base mr-3 hover:underline cursor-pointer outline-none truncate',
  rightContent: 'flex items-center',
  profilePicture: 'cursor-default',
  resolved: 'text-grey-5 dark:text-mauve-3 line-through',
};
